import React, { useState, useEffect, useContext, useCallback } from "react";
import Breadcrumb from "./Breadcrumb";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import { CustomerService } from "../../../services/customer-service";
import { Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import AuthContext from "../../../context/auth-context";
import SearchList from "./SearchList";

export const Customerlistcontent = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "USERS" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "USERS" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }
    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD";
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const history = useHistory();

  const [state, setState] = useState(false);

  const [submitloading, setSubmitLoading] = useState(true);

  const [customerID, setcustomerID] = useState();

  const [customers, setCustomer] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const handleChangeSearchTerm = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  const handleShow4 = (e) => {
    setState({ show4: true });
    setcustomerID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };


  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await CustomerService.customerDelete(customerID);

      setSubmitLoading(true);
      notify("Customer successfully deleted");
      handleClose();
      setPage(0);
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  const fetchCustomers = useCallback(async () => {
    try {
      const result = await CustomerService.customerDetails(rowsPerPage, page, searchTerm);
      setCustomer(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      console.error(err);
    }
  }, [rowsPerPage, page, searchTerm]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);


  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "name",
      headerName: "Customer Name",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "otp_code",
      headerName: "OTP",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "phone",
      headerName: "Phone 1",
      flex: 3,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "whatsapp_number",
      headerName: "Phone 2",
      flex: 3,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "created_at",
      headerName: "Created Date",
      sortable: false,
      flex: 3,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.created_at).format(format2)}</div>;
      },
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.status === "ACTIVE") {
          return (
            <div>
              <span className="badge badge-success">ACTIVE</span>
            </div>
          );
        } else {
          return (
            <div>
              {" "}
              <span className="badge badge-primary">DEACTIVE</span>
            </div>
          );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            hidden={editHide}
            onClick={() => {
              history.push(`/customer-edit/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div hidden={deleteHide}>
            <i
              className="far fa-trash-alt ms-text-danger"
              onClick={() => {
                handleShow4(params.row.id);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <h6>Customer List </h6>
                </div>
                {/* search for customer */}

                  <SearchList
                    handleChange={handleChangeSearchTerm}
                    searchTerm={searchTerm}
                  />
                <div>
                  <Modal
                    show={state.show4}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <h3 className="modal-title has-icon ms-icon-round ">
                        Confirm Deletion
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={handleClose}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </Modal.Header>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "2vh",
                      }}
                    >
                      <h6 style={{ color: "red" }}>
                        Are you sure you want to remove this item ?
                      </h6>
                    </div>
                    <Modal.Footer>
                      <div className="col-md-2" hidden={submitloading}>
                        <div className="spinner spinner-7">
                          <div className="bounce1" />
                          <div className="bounce2" />
                          <div className="bounce3" />
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        // onClick={submitForm}
                        style={{ backgroundColor: "red" }}
                        onClick={onDelete}
                      >
                        Delete
                      </button>

                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <div className="ms-panel-body">
                  <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                    <DataGrid
                      rows={customers}
                      columns={columns}
                      disableExtendRowFullWidth={false}
                      pageSize={rowsPerPage}
                      pagination
                      hideFooter
                      autoHeight
                    />
                    <TablePagination
                      component="div"
                      count={count}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Customerlistcontent;
